const pad = (n: number) => String(n).padStart(2, '0');

export const buildSiteListFilename = (businessCentralId: string, now: Date): string => {
    const safeId = businessCentralId.replace(/[^a-zA-Z0-9._-]/g, '_');
    const date = `${now.getUTCFullYear()}-${pad(now.getUTCMonth() + 1)}-${pad(now.getUTCDate())}`;
    const time = `${pad(now.getUTCHours())}-${pad(now.getUTCMinutes())}-${pad(now.getUTCSeconds())}`;
    return `${safeId}-site-list-${date}_${time}.csv`;
};
